'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { RoomCardSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/RoomCard';
import SectionHeader from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SectionHeader';
import { SearchContentType, useWorldsSearch } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/useWorldsSearch';
import WorldsListItem from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/WorldsListItem';
import { LoadingDots } from '@/components/LoadingDots';
import { ViverseWorldCardSkeleton } from '@/components/ViverseWorldCardSkeleton';
import { cn } from '@/lib/utils';
type WorldsListProps = {
  enablePagination: boolean;
  contentType: SearchContentType;
};
const TITLE_KEY: Record<SearchContentType, string> = {
  games: 'worlds-landing.search.tabs.games',
  experiences: 'worlds-landing.search.tabs.experiences',
  videos: 'media-browser.nav_title.videos'
};
export default function WorldsList(t0) {
  const $ = _c(31);
  const {
    enablePagination,
    contentType
  } = t0;
  const t = useTranslations();
  const {
    allItems,
    isPending,
    isLoading,
    isValidating,
    isRouteLoading,
    enableLoadMore,
    loadMoreRef
  } = useWorldsSearch(contentType, enablePagination);
  if (!isPending && allItems.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== allItems || $[1] !== contentType || $[2] !== enablePagination || $[3] !== isPending || $[4] !== isRouteLoading) {
    t1 = () => {
      const isShowingSkeleton = isRouteLoading || isPending;
      if (isShowingSkeleton && !enablePagination) {
        return Array.from({
          length: 3
        }).map(_temp);
      }
      if (isShowingSkeleton) {
        return Array.from({
          length: 20
        }).map(_temp2);
      }
      return allItems.map((world, i_1) => <WorldsListItem key={`${world.id}-${i_1}`} world={world} enablePagination={enablePagination} contentType={contentType} />);
    };
    $[0] = allItems;
    $[1] = contentType;
    $[2] = enablePagination;
    $[3] = isPending;
    $[4] = isRouteLoading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const renderItems = t1;
  const t2 = TITLE_KEY[contentType];
  let t3;
  if ($[6] !== t || $[7] !== t2) {
    t3 = t(t2);
    $[6] = t;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <SectionHeader title={t3} viewAllHref="/#explore-viverse" />;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !enablePagination;
  let t6;
  if ($[11] !== enablePagination || $[12] !== t5) {
    t6 = cn("flex gap-2", {
      "flex-col lg:gap-5": t5,
      "1.5xl:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] grid grid-cols-2 gap-4 md:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] md:gap-6": enablePagination
    });
    $[11] = enablePagination;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== renderItems) {
    t7 = renderItems();
    $[14] = renderItems;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== enableLoadMore || $[20] !== loadMoreRef) {
    t9 = enableLoadMore && <div ref={loadMoreRef} className="h-4" />;
    $[19] = enableLoadMore;
    $[20] = loadMoreRef;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== enablePagination || $[23] !== isLoading || $[24] !== isValidating) {
    t10 = (isLoading || isValidating) && enablePagination && <LoadingDots />;
    $[22] = enablePagination;
    $[23] = isLoading;
    $[24] = isValidating;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t4 || $[28] !== t8 || $[29] !== t9) {
    t11 = <div className="flex flex-col gap-4 lg:gap-5">{t4}{t8}{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t4;
    $[28] = t8;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}
function _temp2(__0, i_0) {
  return <ViverseWorldCardSkeleton key={i_0} className="aspect-video h-auto p-0" />;
}
function _temp(_, i) {
  return <RoomCardSkeleton key={i} />;
}